import React from "react";
import { FaPlus } from "react-icons/fa";
import { useLocation } from "react-router-dom";

const AccumulativeBtn = ({ onRequestToggle, activeRequest }) => {
  const location = useLocation();
  // Show same sidebar for Monazam, OPAP, and E-Hajj Account tabs in Monazam Portal
  const isMonazamPortalLedger = location.pathname.includes("/monazamaccount") || 
                                 location.pathname.includes("/opap") || 
                                 location.pathname.includes("/ehajj");
  
  const menuItems = [
    { id: "accumulative", label: "Accumulative Request" },
    { id: "reversal-accumulative", label: "Reversal Accumulative Request" },
    { id: "reversal-incoming", label: "Reversal Incoming Request" },
    // Show Unclaimed Request and Expense in all Monazam Portal ledger tabs
    ...(isMonazamPortalLedger ? [{ id: "unclaimed", label: "Unclaimed Request" }] : []),
    ...(isMonazamPortalLedger ? [{ id: "expense", label: "Expense" }] : [])
  ];

  return (
    <div className="mb-3">
      {menuItems.map((item) => (
        <div key={item.id} className="mb-2">
          <button
            className={`btn label-text d-flex align-items-center w-100 sidebar-button ${
              activeRequest === item.id ? "active" : ""
            }`}
            onClick={() => onRequestToggle(item.id)}
          >
            {item.label} <FaPlus className="plus-icon" />
          </button>
        </div>
      ))}
    </div>
  );
};

export default AccumulativeBtn;
